import React from "react";
import { CommunityBanner } from "../clientSettings/tabs";



export const Communitybanner=(props)=>{
    return(
        <CommunityBanner type="Community" {...props}/>
    )
}